import React, { useEffect, useState } from "react";

import {
  Col,
  Row,
  Card,
  Button,
  Badge,
  Table,
  Form,Modal,Nav,Pagination
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import swal from "sweetalert";
import { faDownload, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import "../../scss/fcsvendor/layout/_vendor.scss";
import { useParams } from "react-router-dom";
import { getContract,getFiles,createFile,downloadFile } from "../../app/api";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import Loader from "../../components/Loader";
import ButtonLoader from "../../components/ButtonLoader";
import Loadericon from "../../components/Loadericon";
import { useCreateNotesMutation } from "../../store/app/apislice";
export default () => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [notesDescription, setNotesDescription] = useState("");
  const [titleNotes, setTitleNotes] = useState("");

  const [file2, setFile2] = useState("");

    const [file, setFile] = useState("");
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [title2, setTitle2] = useState("");
  
  const [title, setTitle] = useState("");
  const history = useHistory();
  const [totalPages, setTotalPages] = useState(0); // State to hold total pages
  const [page, setPage] = useState(1);
  const [vendor, setVendor] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [date, setDate] = useState("");
  const [signdate, setSignDate] = useState("");
    const [downloadingFileId, setDownloadingFileId] = useState(null);
    const [FileManagement, setFileManagement] = useState([]); // State to hold vendor data
  
  const [loading, setLoading] = useState(false);
  const [createNotes, { isLoading: isCreatingNotes }] = useCreateNotesMutation();
  const fetchSingleContract = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getContract(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      // console.log(response.data);
      setTitle(response.data?.data?.title);

      setDate(response.data?.data?.expiration_date);
      setVendor(response.data?.data?.vendor_id);
      setSignDate(response.data?.data?.vendorsigndate);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSingleContract();
  }, [id]);
  const expiryDate = new Date(date);
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const timeDifference = expiryDate - currentDate;

  // Convert the difference to days
  const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

  // Determine the badge color
  const badgeColor = daysDifference <= 15 ? "danger" : "primary";
  const handleBackClick = () => {
    history.push(Routes.Contracts.path);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();
      formData.append("category", "Vendor");
      formData.append("title", title2);
      formData.append("file", file);

      const response = await axios.post(createFile(), formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Important for file uploads
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });

      swal({
        text: response.data.message,
        icon: "success",
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
      setShow(false);
      fetchFilemanagment(page);
      setTitle2("");
      setFile("");
    }
  };
  const handleDownload = async (id, files) => {
    setDownloadingFileId(id);
    try {
      const token = localStorage.getItem("token");

      // Make the API call to get the file
      const response = await axios.get(downloadFile(id), {
        responseType: "blob", // Important: Set responseType to 'blob' to handle binary data
        headers: {
          "Content-Type": "multipart/form-data",
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });

      // Find the file metadata from the `files` array
      const fileMetadata = files.find((file) => file.id === id);
      const originalName =
        fileMetadata?.title_with_extension || "downloaded_file";

      // Create a Blob from the response data
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = originalName; // Use the original_name from the metadata

      // Append the link to the DOM, trigger the download, and remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Show a success message
      swal({
        text: "File Downloaded Successfully",
        icon: "success",
      });
    } catch (error) {
      // Show an error message if something goes wrong
      swal({
        text:
          error.response?.data?.message ||
          "An error occurred while downloading the file",
        icon: "error",
      });
    } finally {
      setDownloadingFileId(null); // Reset the downloading state
    }
  };
  const fetchFilemanagment = async (currentPage) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getFiles(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
        },
      });
      // console.log(response.data);

      setFileManagement(response.data?.files);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmitNotes = async () => {

    const notesData = {
      title: titleNotes,
      description: notesDescription,
      
    };

    try {
      const response = await createNotes(notesData).unwrap();
     
        swal({
          text: response.data.message,
          icon: "success",
        });
        setTitleNotes(""); // Reset title
        setNotesDescription(""); // Reset description
        handleClose2(); // Close the modal
      
    } catch (error) {
      swal({
        text: error.data.messages.error,
        icon: "error",
      });
      console.log("Error creating notes:", error);
    }finally {
      handleClose2();
    }
  };

  useEffect(() => {
    fetchFilemanagment(page);
  }, [page]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
            <div className="d-block  mb-md-0">
              <h4 className="mb-0">Contracts Details</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleBackClick}
              className=" me-2"
            >
              <span>Back</span>
            </Button>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Title:</p>{" "}
                        <p className="vendor-detail">{title}</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Vendor Name:</p>
                        <p className="vendor-detail"> N/A</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Template:</p>
                        <p className="vendor-detail">N/A</p>{" "}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Sent Detail:</p>{" "}
                        <p className="vendor-detail">N/A</p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Sign Date:</p>
                        <p className="vendor-detail">
                          {" "}
                          {signdate === "0000-00-00 00:00:00"
                            ? "Not Signed"
                            : `${moment(signdate).format("MM/DD/YYYY HH:mm")}`}
                        </p>{" "}
                      </Col>

                      <Col xs={12} sm={6} xl={4} lg={4}>
                        <p className="vendor-title">Expiry Date:</p>
                        <p className="vendor-detail">
                          <Badge
                            pill
                            bg={badgeColor}
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.85rem",
                              border: "1px solid #ddd",
                            }}
                          >
                           
                            {moment(date).format("MM/DD/YYYY HH:mm")}
                          </Badge>
                        </p>{" "}
                      </Col>
                    </Row>
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-4 mb-md-0">
              <h4>Contracts Documents</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleShow}
              className=" me-2"
            >
              <span>Upload Document</span>
            </Button>
          </div>
          <Row className="justify-content-md-center">
            <Card
              border="light"
              className="table-wrapper table-responsive shadow-sm mb-4"
            >
              <Card.Body className="p-0">
                <Table responsive className="user-table align-items-center">
                  <thead>
                    <tr>
                      <th className="border-0">Title</th>
                      <th className="border-0">Name</th>

                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {FileManagement.map((files) => {
                    return (
                    <tr>
                      <td className="fw-bold">{files?.title}</td>
                      <td>{files?.title_with_extension}</td>

                      <td>
                         {downloadingFileId === files?.id ? ( // Check if this file is being downloaded
                                                    <div className="d-flex justify-content-start h-3">
                                                      <Loadericon />
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        handleDownload(files?.id, FileManagement)
                                                      }
                                                    >
                                                      <FontAwesomeIcon icon={faDownload} />
                                                    </div>
                                                  )}
                      </td>
                    </tr>
                    );
                    })}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Nav className="justify-content-center mb-4">
  <Pagination className="mb-2 mb-lg-0">
    <Pagination.Prev
      onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
    />
    {Array.from({ length: totalPages }, (_, index) => (
      <Pagination.Item
        key={index + 1}
        active={index + 1 === page}
        onClick={() => setPage(index + 1)}
      >
        {index + 1}
      </Pagination.Item>
    ))}
    <Pagination.Next
      onClick={() =>
        setPage((prev) => Math.min(prev + 1, totalPages))
      }
    />
  </Pagination>
</Nav>
          </Row>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-4 mb-md-0">
              <h4>Notes</h4>
            </div>
            <Button
              variant="primary"
              onClick={handleShow2}
              className=" me-2"
            >
              <span>Add Notes</span>
            </Button>
          </div>
          <Row className="justify-content-md-center">
            <Card
              border="light"
              className="table-wrapper table-responsive shadow-sm"
            >
              <Card.Body className="p-0">
                <Table responsive className="user-table align-items-center">
                  <thead>
                    <tr>
                      <th className="border-0">Added by</th>
                      <th className="border-0">Date time</th>

                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>james</td>
                      <td>04/05/2025</td>

                      <td>
                        <div style={{ cursor: "pointer" }}>
                          <FontAwesomeIcon icon={faDownload} />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Row>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
            <div className="d-block mb-4 mb-md-0">
              <h4>Document Template</h4>
            </div>
          </div>

          <Row className="justify-content-md-center">
            <Col xs={12} sm={12} xl={12} lg={12} className="mb-4">
              <Card border="light" className="shadow-sm">
                <Card.Body>
                  <Col xs={12} sm={12} xl={12} lg={12}>
                    <Row>
                      <Col xs={12} sm={6} xl={6} lg={6}>
                        <Form.Group id="Template">
                          
                          <Form.Select>
                            <option value="0">Select Templates</option>
                            <option value="0">Template 1</option>
                            <option value="0">Template 2</option>
                            <option value="0">Template 3</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} xl={6} lg={6} style={{float:"right"}}>
                        <Button variant="primary" className="me-2">
                          <FontAwesomeIcon
                            icon={faPaperPlane}
                            className="me-2"
                          />
                          <span>Send</span>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
           <Modal
                      style={{ top: "15%" }}
                      show={show}
                      onHide={handleClose}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Contract Document</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group id="title">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Title"
                            value={title2} // Bind to state
                            onChange={(e) => setTitle2(e.target.value)}
                          />
                        </Form.Group>
                        
                        <div className="mb-3 mt-2">
                          <label for="formFile" className="form-label">
                            Upload File
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="formFile"
                            onChange={(e) => setFile(e.target.files[0])}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                          Close
                        </Button>
                        {loadingBtn ? (
                          <div className="d-flex justify-content-start">
                            <ButtonLoader />
                          </div>
                        ) : (
                          <Button variant="primary" onClick={handleSubmit}>
                            Save changes
                          </Button>
                        )}
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      style={{ top: "15%" }}
                      show={show2}
                      onHide={handleClose2}
                      scrollable
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Contract Notes</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <Form.Group id="title" className="mb-2">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            
                            type="text"
                            placeholder="Enter Title"
                            value={titleNotes} // Bind to state
                            onChange={(e) => setTitleNotes(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group id="Note">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                          className="custom-textarea" 
                            required
                            as="textarea"
                            placeholder="Enter Description      "
                            value={notesDescription} // Bind to state
                            onChange={(e) => setNotesDescription(e.target.value)}
                          />
                        </Form.Group>
                        
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="primary" onClick={handleClose2}>
                          Close
                        </Button>
                        {loadingBtn ? (
                          <div className="d-flex justify-content-start">
                            <ButtonLoader />
                          </div>
                        ) : (
                          <Button variant="primary" onClick={handleSubmitNotes} >
                            Save changes
                          </Button>
                        )}
                      </Modal.Footer>
                    </Modal>
        </div>
      )}
    </>
  );
};
